import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { UPDATE_NAV_ITEM } from '../../../../../sites/aflm/store/js/modules/competition-nav/actions';
import { navSelector } from '../../../../../sites/aflm/store/js/modules/competition-nav/selectors/nav-selector';
import { Loader } from '../../../../../common/react/components/Loader';

import { RoundButton } from './RoundButton';

export const RoundListNavItem = () => {
    const dispatch = useDispatch();
    const nav = useSelector(navSelector);
    const season = useSelector(
        (state) =>
            state.seasons[`competition_${nav.competition.id}`]?.[
                `season_${nav.season.id}`
            ]
    );
    const roundsList = useSelector(
        (state) => state.rounds[`season_${nav.season.id}`]?.list
    );

    if (!roundsList) {
        return (
            <ul className="competition-nav__round-list">
                <Loader />
            </ul>
        );
    }

    const onNavItemClick = (event, label) => {
        dispatch(
            UPDATE_NAV_ITEM.request({
                navItem: 'round',
                value: label
            })
        );
    };

    return (
        <ul className="competition-nav__round-list">
            {roundsList.length
                ? roundsList.map((round, index) => (
                      <RoundButton
                          key={index}
                          round={round}
                          currentRoundNumber={season?.currentRoundNumber ?? -1}
                          onClick={onNavItemClick}
                      />
                  ))
                : ''}
        </ul>
    );
};
